export default "__VITE_ASSET__Bw7kEaTb__"